export enum SentryBreadcrumbCategory {
  config = 'configuration',
  serviceWorker = 'service-worker'
}
